import React from 'react'
import { graphql, HeadProps } from 'gatsby'
import { Layout } from '../components/Layout'
import { Header } from '../containers/Header'
import { Footer } from '../containers/Footer'
import { CommonHead } from '../components/CommonHead'
import { cloudinaryImage } from '../cloudinary'
import { GatsbySiteMetaData } from '../app-types'
import { SectionContentInstanceMissionHero } from '../sections/instances/SectionContentInstanceMissionHero'
import { SectionContentInstanceMissionStatement } from '../sections/instances/SectionContentInstanceMissionStatement'
import { SectionContentInstanceMissionValues } from '../sections/instances/SectionContentInstanceMissionValues'
import { SectionContentInstanceMissionAccomplishments } from '../sections/instances/SectionContentInstanceMissionAccomplishments'

interface PageQueryType {
  site: GatsbySiteMetaData
}

export const Head = ({ data, location }: HeadProps<PageQueryType>) => (
  <CommonHead
    title="Qwick's Mission"
    description="Qwick is revolutionizing the hospitality industry by connecting businesses and workers to new opportunities. This is provided with a data-driven, innovative, and customer-centric approach to provide the best experience for businesses and workers alike."
    image={cloudinaryImage('photography/our-vision').toURL()}
    url={data.site.siteMetadata.siteUrl + location.pathname}
  />
)

const Page = () => (
  <Layout header={<Header />}>
    <SectionContentInstanceMissionHero />
    <SectionContentInstanceMissionStatement />
    <SectionContentInstanceMissionValues />
    <SectionContentInstanceMissionAccomplishments />
    <Footer />
  </Layout>
)

export const query = graphql`
  query missionPageQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

export default Page
